<script>
  import CarouselJS from "./elementos/CarouselJS.svelte";

  function reveal(node) {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          node.style.opacity = "1";
          node.style.transform = "translateY(0)";
          observer.unobserve(node);
        }
      },
      { threshold: 0.15 },
    );
    requestAnimationFrame(() => observer.observe(node));
    return { destroy: () => observer.disconnect() };
  }
</script>

<div class="app">
  <div class="section section--carousel" use:reveal>
    <CarouselJS />
  </div>

  <div class="section" use:reveal>
    <div class="content content--reverse">
      <div class="content__text">
        <h2>Cada mesa, cada cliente, todo bajo control</h2>
        <p>
          Datos clave para tomar decisiones estratégicas que alineen mejor el
          restaurante con las expectativas del mercado
        </p>

        <p>Un buen manejo de cada detalle es clave para el éxito global</p>
        <p>Identifica qué aspectos del servicio o del menú necesitan ajustes</p>
        <p>Conoces los puntos fuertes del restaurante</p>
      </div>
      <div class="content__image">
        <img src="/home_img/content/2.png" alt="Imagen secci&oacute;n 1" />
      </div>
    </div>
  </div>

  <div class="section" use:reveal>
    <div class="content content--reverse">
      <div class="content__image">
        <img src="/home_img/content/1.png" alt="Imagen secci&oacute;n 2" />
      </div>
      <div class="content__text">
        <div class="icon-row">
          <span class="icon-circle"><i class="bi bi-lightning"></i></span>
          <div class="recuadro">
            <p>
              <strong>Monitoreo Integral del Flujo de Pedidos</strong>
            </p>
            <strong>Mesas más activas</strong>
            <p>
              Identifica qué mesas están solicitando servicio con mayor
              frecuencia.
            </p>

            <strong>Volumen de solicitudes</strong>
            <p>
              La cantidad total de pedidos o llamados realizados por cada mesa.
            </p>

            <strong>Tiempo promedio de entrega</strong>
            <p>
              El tiempo medio que transcurre desde que se toma el pedido hasta
              que llega a la mesa.
            </p>

            <strong>Registro de tiempos </strong>
            <p>
              El historial exacto con la hora de cada solicitud y atención
              brindada.
            </p>
            <p></p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="section" use:reveal>
    <div class="content content--reverse">
      <div class="content__text">
        <div class="icon-row">
          <span class="icon-circle"><i class="bi bi-bell-fill"></i></span>
          <div class="recuadro">
            <p>
              <strong>El control de tu servicio, directo en tu bolsillo.</strong>
            </p>
            <p>
              Recibe notificaciones en tiempo real cada vez que un cliente solicite atención o realice un pedido. Monitorea el pulso de tu negocio desde cualquier lugar, optimiza los tiempos de respuesta de tu equipo y garantiza una experiencia impecable que haga volver a tus clientes. Tu restaurante, siempre conectado, siempre eficiente.
            </p>
          </div>
        </div>
      </div>
      <div class="content__image">
        <img src="/home_img/content/3.png" alt="Imagen secci&oacute;n 2" />
      </div>
    </div>
  </div>
</div>

<style>
  :global(*) {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  .app {
    background: #fbf6ea;
    font-family: "DM Sans", system-ui, -apple-system, sans-serif;
    color: #2c3320;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 30px 60px;
    display: flex;
    flex-direction: column;
    gap: 40px;
  }

  .section {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transform: translateY(30px);
    transition:
      opacity 0.8s ease,
      transform 0.8s ease;
  }

  .section--carousel {
    padding-top: 10px;
  }

  .content {
    display: flex;
    align-items: center;
    gap: 50px;
  }

  .content--reverse {
    flex-direction: row;
  }

  .content__text {
    flex: 1;
    min-width: 0;
  }

  .content__text h2 {
    font-family: "Fraunces", ui-serif, Georgia, serif;
    font-weight: 600;
    font-size: 1.9rem;
    margin-bottom: 16px;
    color: #2c3320;
  }

  .content__text p {
    font-size: 1rem;
    line-height: 1.7;
    color: #4a5240;
    margin-bottom: 12px;
  }

  .content__image {
    flex-shrink: 0;
    width: 350px;
    height: 350px;
    border-radius: 28px;
    box-shadow: 0 12px 32px rgba(44, 51, 32, 0.12);
  }

  .content__image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    border-radius: 28px;
  }

  .icon-row {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .icon-circle {
    flex-shrink: 0;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.3rem;
    color: #fbf6ea;
    background: #7e934e;
    margin-top: 4px;
  }

  .recuadro {
    flex: 1;
    background: #f3ead5;
    border-radius: 20px;
    padding: 20px;
    box-shadow: 0 4px 16px rgba(44, 51, 32, 0.08);
  }

  .recuadro strong {
    color: #2c3320;
  }

  .recuadro p:first-child {
    margin-bottom: 8px;
  }

  .recuadro p:last-child {
    margin-bottom: 0;
  }

  @media (min-width: 769px) and (max-width: 1024px) {
    .content {
      gap: 30px;
    }

    .content__image {
      width: clamp(250px, 40%, 350px);
    }
  }

  @media (max-width: 768px) {
    .section {
      min-height: auto;
    }

    .app {
      padding: 0 16px 40px;
      gap: 40px;
    }

    .content {
      flex-direction: column;
      gap: 16px;
    }

    .content--reverse {
      flex-direction: column;
    }

    .content__text {
      order: 0;
    }

    .content__image {
      order: 1;
      width: 100%;
      max-width: 350px;
      height: auto;
      aspect-ratio: 1 / 1;
    }

    .icon-row {
      flex-direction: column;
      align-items: center;
    }
  }
</style>
